import React from 'react';
import { useTranslation } from 'react-i18next';
import GoogleMap from "../components/GoogleMap"

const Contact = () => {
  const { t } = useTranslation();

  return (
    <div className='bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 mt-4'>
      <section className="contact-section pt-16 pb-8 pl-8 pr-8 lg:pt-24 lg:pb-12 lg:pl-12 lg:pr-12">
        <h1 className="text-4xl mb-14">{t('contact.title')}</h1>

        {/* Indirizzo e contatti */}
        <div className="mt-4">
          <h3 className="text-xl sm:text-xl md:text-xl lg:text-2xl font-bold">{t('contact.address.title')}</h3>
          <p className="mt-2 text-lg sm:text-lg md:text-lg lg:text-xl">{t('contact.address.street')}</p>
          <p className="text-lg sm:text-lg md:text-lg lg:text-xl">{t('contact.address.city')}</p>
          <p className="text-lg sm:text-lg md:text-lg lg:text-xl">{t('contact.address.citofono')}</p>
          <p>
            <a href="tel:+390249469659" className="text-blue-500 hover:underline text-lg sm:text-lg md:text-lg lg:text-xl">
              {t('contact.address.phone')}
            </a>
          </p>
          <p>
            <a href="mailto:info@galimbertirappresentanze.it" className="text-blue-500 hover:underline text-lg sm:text-lg md:text-lg lg:text-xl">
              {t('contact.address.email')}
            </a>
          </p>
        </div>

        {/* Indicazioni stradali */}
        <div className="mt-8">
          <h3 className="text-xl sm:text-xl md:text-xl lg:text-2xl font-bold">{t('contact.directions.title')}</h3>
          <p className="mt-2 text-lg sm:text-lg md:text-lg lg:text-xl">{t('contact.directions.details')}</p>
        </div>

        {/* Orari di apertura */}
        <div className="mt-8">
          <h3 className="text-xl sm:text-xl md:text-xl lg:text-2xl font-bold">{t('contact.openingHours.title')}</h3>
          <p className="mt-2 whitespace-pre-line text-lg sm:text-lg md:text-lg lg:text-xl">{t('contact.openingHours.details')}</p>
        </div>

        <div className="mt-8">
          <GoogleMap/>
        </div>
      </section>
    </div>
  );
};

export default Contact;
